import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    { key: 'ID', label: 'id', type: 'number', defaultShow: true },
    { key: 'SHIPPER_CODE', label: 'shipper', type: 'select', selectOption: 'shipperCodes', defaultShow: true },
    {
        key: 'SERVICE_CODE_VALUE',
        label: 'service',
        type: 'select',
        selectOption: 'serviceCodes',
        defaultShow: true,
    },
    { key: 'COUNTRY_CODE', label: 'country', type: 'select', selectOption: 'countryOptionsCodes', defaultShow: true },
    { key: 'EGON_DELIVERY', label: 'egonDelivery', defaultShow: true },
    { key: 'EGON_TRANSFER_TYPE', label: 'transferType', type: 'number', defaultShow: true },
    { key: 'ENABLED', label: 'enabled', type: 'select', selectOption: 'boolNumberCodes', defaultShow: true },
    { key: 'NOTE', label: 'note', defaultShow: true },
    { key: 'UPDATED_AT', label: 'updatedAt', type: 'dateTime', defaultShow: true },
    { key: 'UPDATED_BY', label: 'updatedBy', defaultShow: false },
];
